import styled from "styled-components";

export const ExpressionsGrid = styled.div<{ columnCount: number }>`
    display: grid;
    grid-template-columns: repeat(${(props) => props.columnCount}, 1fr);
    column-gap: 8px;
    row-gap: 8px;
`;
